import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";
import {getDatabaseCodeTransformer} from "./transfomers/transformers";
import {toTransportGaugeType, TransportGaugeType} from "./transport-gauge-type";

export const TransportGaugeValidator = t.intersection([
  t.type({
    id: t.string,
    transportId: t.string,
    regionId: t.string,
    type: t.string,
  }),
  t.partial({
    containerId: t.string,
    containerName: t.string,
    containerAbbr: t.string,
    topValue: t.number,
    bottomValue: t.number,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const TransportGaugeArrayValidator = t.array(TransportGaugeValidator);

export type TransportGauge = t.TypeOf<typeof TransportGaugeValidator>;
export type TransportGaugeArray = t.TypeOf<typeof TransportGaugeArrayValidator>;

@Exclude()
export class TransportGaugeEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  transportId!: string;

  @Expose()
  containerId?: string;

  @Expose()
  containerName?: string;

  @Expose()
  containerAbbr?: string

  @Expose()
  regionId!: string

  @Expose()
  topValue?: number;

  @Expose()
  bottomValue?: number;

  @Expose()
  @Transform(getDatabaseCodeTransformer(toTransportGaugeType))
  type!: TransportGaugeType

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'TRANSPORTGAUGE';

  get displayName(): Readonly<string> {
    return this.id
  }

  /**
   * Constructor for TransportGaugeEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: TransportGauge): TransportGaugeEntity {
    return plainToInstance(TransportGaugeEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<TransportGauge> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(TransportGaugeValidator, object);
  }

  asTypeValue(): TransportGauge {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(TransportGaugeValidator, object);
  }
}
